export function getFaviconUrl(siteUrl, apiBase = process.env.REACT_APP_API_BASE_URL || '/api') {
  try {
    if (!siteUrl) return null;
    const u = new URL(siteUrl);
    const domainUrl = `${u.protocol}//${u.hostname}`;
    // Resolve real URL via JSON endpoint, to avoid exposing API URL in <img src>
    const encoded = encodeURIComponent(domainUrl);
    return `${apiBase}/utils/favicon_url?url=${encoded}`;
  } catch (e) {
    return null;
  }
}

export function getFaviconFallback() {
  // Transparent 1x1 PNG data URI as last resort
  return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
}


